package de.oevbs.kunde.kundenportal2.services.mydata

import de.oevbs.businesspartner.bpcrmservice2.bankaccount.model.BankAccount
import de.oevbs.kunde.kundenportal2.GeneralProgressStep
import de.oevbs.kunde.kundenportal2.authentication.PortalSessionMiddleware
import de.oevbs.kunde.kundenportal2.components.GlobalServiceMessagesStore
import de.oevbs.kunde.kundenportal2.components.globalInitTracker
import de.oevbs.kunde.kundenportal2.util.tryCatchAndHandleErrors
import de.oevbs.sfa.communication.use
import dev.fritz2.core.Handler
import dev.fritz2.core.RootStore
import dev.fritz2.core.storeOf
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.Flow

class BankAccountsStore(job: Job) : RootStore<List<BankAccount>>(emptyList(), job) {

    private val client = MyDataClient().use(PortalSessionMiddleware)

    private val initFailedStore = storeOf(false, Job())
    val initFailedFlow: Flow<Boolean> = initFailedStore.data

    val progress = storeOf(GeneralProgressStep.SUBMIT1, job)

    val lastChangedBankAccount = storeOf<BankAccount?>(null, job)

    val initBankAccountsModel: Handler<Unit> = handle { current ->
        GlobalServiceMessagesStore.clear(Unit)
        globalInitTracker.track {
            val allAccounts = loadBankAccounts()
            if (allAccounts == null) {
                initFailedStore.update(true)
                return@track current
            }
            allAccounts
        }
    }

    private suspend fun loadBankAccounts(): List<BankAccount>? {
        return tryCatchAndHandleErrors("Initialisieren der Bankdaten") {
            client.initBankData()
        }
    }
}